/* tslint:disable */

declare var Object: any;
export interface TeompositionInterface {
  "positionId"?: number;
  "posCode": string;
  "companyId": number;
  "parentId": number;
  "posNameEn": string;
  "posNameId": string;
  "posNameMy": string;
  "posNameTh": string;
  "jobdescEn"?: string;
  "jobdescId"?: string;
  "jobdescMy"?: string;
  "jobdescTh"?: string;
  "posLevel": number;
  "parentPath": string;
  "posFlag": number;
  "posActive": number;
  "deptId": number;
  "dorder": number;
  "reportTopos"?: number;
  "clevel"?: number;
  "corder"?: number;
  "changeflag"?: string;
  "reportPostype"?: string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "orgLevel"?: string;
  "lstworklocation"?: string;
  "lstgradecode"?: string;
  "headDiv"?: number;
  "jobtitleCode"?: string;
  "jobstatuscode"?: string;
  "costcenterCode"?: string;
  "requireSuccessor"?: string;
  "filename"?: string;
  rel_empcompany?: any[];
}

export class Teomposition implements TeompositionInterface {
  "positionId": number;
  "posCode": string;
  "companyId": number;
  "parentId": number;
  "posNameEn": string;
  "posNameId": string;
  "posNameMy": string;
  "posNameTh": string;
  "jobdescEn": string;
  "jobdescId": string;
  "jobdescMy": string;
  "jobdescTh": string;
  "posLevel": number;
  "parentPath": string;
  "posFlag": number;
  "posActive": number;
  "deptId": number;
  "dorder": number;
  "reportTopos": number;
  "clevel": number;
  "corder": number;
  "changeflag": string;
  "reportPostype": string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "orgLevel": string;
  "lstworklocation": string;
  "lstgradecode": string;
  "headDiv": number;
  "jobtitleCode": string;
  "jobstatuscode": string;
  "costcenterCode": string;
  "requireSuccessor": string;
  "filename": string;
  rel_empcompany: any[];
  constructor(data?: TeompositionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teomposition`.
   */
  public static getModelName() {
    return "Teomposition";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teomposition for dynamic purposes.
  **/
  public static factory(data: TeompositionInterface): Teomposition{
    return new Teomposition(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teomposition',
      plural: 'Teompositions',
      path: 'Teompositions',
      properties: {
        "positionId": {
          name: 'positionId',
          type: 'number'
        },
        "posCode": {
          name: 'posCode',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "parentId": {
          name: 'parentId',
          type: 'number'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "posNameId": {
          name: 'posNameId',
          type: 'string'
        },
        "posNameMy": {
          name: 'posNameMy',
          type: 'string'
        },
        "posNameTh": {
          name: 'posNameTh',
          type: 'string'
        },
        "jobdescEn": {
          name: 'jobdescEn',
          type: 'string'
        },
        "jobdescId": {
          name: 'jobdescId',
          type: 'string'
        },
        "jobdescMy": {
          name: 'jobdescMy',
          type: 'string'
        },
        "jobdescTh": {
          name: 'jobdescTh',
          type: 'string'
        },
        "posLevel": {
          name: 'posLevel',
          type: 'number'
        },
        "parentPath": {
          name: 'parentPath',
          type: 'string'
        },
        "posFlag": {
          name: 'posFlag',
          type: 'number'
        },
        "posActive": {
          name: 'posActive',
          type: 'number'
        },
        "deptId": {
          name: 'deptId',
          type: 'number'
        },
        "dorder": {
          name: 'dorder',
          type: 'number'
        },
        "reportTopos": {
          name: 'reportTopos',
          type: 'number'
        },
        "clevel": {
          name: 'clevel',
          type: 'number'
        },
        "corder": {
          name: 'corder',
          type: 'number'
        },
        "changeflag": {
          name: 'changeflag',
          type: 'string'
        },
        "reportPostype": {
          name: 'reportPostype',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "orgLevel": {
          name: 'orgLevel',
          type: 'string'
        },
        "lstworklocation": {
          name: 'lstworklocation',
          type: 'string'
        },
        "lstgradecode": {
          name: 'lstgradecode',
          type: 'string'
        },
        "headDiv": {
          name: 'headDiv',
          type: 'number'
        },
        "jobtitleCode": {
          name: 'jobtitleCode',
          type: 'string'
        },
        "jobstatuscode": {
          name: 'jobstatuscode',
          type: 'string'
        },
        "costcenterCode": {
          name: 'costcenterCode',
          type: 'string'
        },
        "requireSuccessor": {
          name: 'requireSuccessor',
          type: 'string'
        },
        "filename": {
          name: 'filename',
          type: 'string'
        },
      },
      relations: {
        rel_empcompany: {
          name: 'rel_empcompany',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teomposition.ts